import React from "react";
import {
  Alert,
  Badge,
  Form,
  Icon,
  Input,
  Button,
  Select,
  DatePicker,
  Row,
  Col,
  Upload,
  InputNumber,
  TreeSelect,
} from "antd";
import get from "lodash/get";
import map from "lodash/map";
import findIndex from "lodash/findIndex";
import { connect } from "react-redux";

import FileLink from "../FileLink/FileLink";

import {
  updateDocumentRequest,
  createDocumentRequest,
  createPatientProfileDocumentRequest,
  updatePatientProfileDocumentRequest,
  getSitesRequest,
} from "../../api/requests";

import {
    getDocumentCreatePermission,
    getDocumentUpdatePermission,
    getDocumentTrainingReadPermission,
    getDocumentPublicReadPermission,
    getDocumentPerSiteReadPermission,
    getDocumentGeneralPrivateReadPermission,
    getDocumentGeneralReadPermission,
    getDocumentValidationReadPermission,
    getDocumentPharmacyBinderPermission,
    getDocumentStudyRegulatoryBinderPermission,
    getPatientDocumentCreatePermission,
    getPatientDocumentUpdatePermission, getDocumentPerSitePrivateReadPermission,
} from "../../reducers/user/selectors";

import classes from "./DocumentForm.css";
import { logout } from "../../reducers/user/actions";
import { getFormErrorMessage } from "../../utils/errorHandler";
import moment from "moment";
import { withNamespaces } from "react-i18next";

const { Option } = Select;
const { TreeNode } = TreeSelect;

export const documentTypes = {
  // Site Specific category
  site_accreditation: "Site accreditation",
  doctor_license: "Professional/Medical license",
  training_completion_certificate: "Training Completion Certificate",
  cv: "CV",
  gcp_certificates: "GCP Certificates",
  reb_ethics_approval_letter:
    "REB/Ethics approval letter, annual renewals, amendments",
  ethics_membership_list: "Ethics Membership List",
  reb_ethics_correspondence: "REB/Ethics Correspondence",
  approved_consent_form:
    "Approved Consent forms for both patient and surrogate",
  site_doa_log: "Site DOA log",
  site_training_log: "Site training log",
  protocol_signature_page: "Protocol Signature Page",
  reba_form: "REBA (Health Canada) Form",
  ctsi: "CTSI",
  qiu: "QIU",
  nol: "NOL",
  site_monitoring: "Site Monitoring",
  // Other
  other: "Other Documents",
  // Public category
  main_study: "Main Study Documents",
  study_manuals: "Study Manuals",
  assessment_tools: "Assessment Tools",
  forms: "Forms",
  siv_presentations: "SIV Presentations",
  relevant_communications: "Relevant Communications",
  // Training Category
  user_guide: "User Guide",
  technical_admin_user_guide: "Technical Admin User Guide",
  // Validation Category
  master_validation_plan: "Master Validation Plan",
  master_validation_report: "Master Validation Report",
  installation_qualication_plan: "Installation Qualication Plan",
  installation_qualication_report: "Installation Qualication Report",
  operational_qualitification_plan: "Operational Qualitification Plan",
  operational_qualitification_report: "Operational Qualitification Report",
  perfomance_qualification_plan: "Perfomance Qualification Plan",
  perfomance_qualification_report: "Perfomance Qualification Report",
  testing_plan: "Testing Plan",
  testing_log: "Testing Log",
  data_managemnt_plan: "Data Management Plan",
  system_architecture: "System Architecture",
  // Study Regulatory Binder
  site_pi_forms: "Site / PI Forms",
  site_personnel_qualifications: "Site Personnel Qualifications",
  forms_agreements: "Forms / Agreements",
  protocol_amendment_signature:
    "Protocol / Amendment(s) Signature Pages and Acknowledgements",
  investigator_brochure_addendum:
    "Investigator Brochure / Addendum(s) Signature Pages and  Acknowledgements",
  informed_consents_forms: "Informed Consents Forms ",
  subject_logs_forms: "Subject Logs & Forms (Completed)",
  "safety ": "Safety  ",
  local_laboratory: "Local Laboratory",
  imaging: "Imaging",
  "competent_authority	": "Competent Authority	",
  irb_iec: "IRB/IEC (Central and Local)",
  other_authority:
    "Other Authority (i.e. Hospital/Scientific Review Board, Radiation committee, etc.)",
  monitoring_documentation: "Monitoring Documentation",
  study_supplies: "Study Supplies",
  site_correspondence: "Site Correspondence",
  equipment: "Equipment",
  // Pharmacy Binder
  study_staff: "Study Staff & Contact Information",
  protocol_amendment: "Protocol / Amendment(s)",
  schedule_of_events: "Schedule of Events (current approved version)",
  investigator_brochure:
    "Investigator Brochure(s) and addendums / Package Inserts",
  pharmacy_manual: "Pharmacy Manual",
  msds_certificates: "MSDS, Certificates of Analysis & QP Release",
  investigational_receipt: "Investigational Product Receipt and Request",
  investigational_dispensing:
    "Investigational Product Dispensing & Accountability",
  investigational_disposition: "Investigational Product Disposition / Return",
  investigational_storage: "Investigational Product Storage   ",
  training_material: "Training Material",
  correspondence: "Correspondence",
  general_patient_document: "General patient document",
};

export const categoryPublic = [
  "main_study",
  "study_manuals",
  "assessment_tools",
  "forms",
  "siv_presentations",
  "relevant_communications",
  "other",
];
export const categoryGeneral = ["other"];
export const categoryGeneralPrivate = ["other"];
export const categoryTraining = [
  "user_guide",
  "technical_admin_user_guide",
  "other",
];
export const categoryPerSite = [
  "site_accreditation",
  "doctor_license",
  "training_completion_certificate",
  "cv",
  "gcp_certificates",
  "reb_ethics_approval_letter",
  "ethics_membership_list",
  "reb_ethics_correspondence",
  "approved_consent_form",
  "site_doa_log",
  "site_training_log",
  "protocol_signature_page",
  "reba_form",
  "ctsi",
  "qiu",
  "site_monitoring",
];
export const categoryValidation = [
  "master_validation_plan",
  "master_validation_report",
  "installation_qualication_plan",
  "installation_qualication_report",
  "operational_qualitification_plan",
  "operational_qualitification_report",
  "perfomance_qualification_plan",
  "perfomance_qualification_report",
  "testing_plan",
  "testing_log",
  "data_managemnt_plan",
  "system_architecture",
  "other",
];
export const categoryStudyRegulatoryBinder = [
  "site_pi_forms",
  "site_personnel_qualifications",
  "forms_agreements",
  "protocol_amendment_signature",
  "investigator_brochure_addendum",
  "informed_consents_forms",
  "subject_logs_forms",
  "safety ",
  "local_laboratory",
  "imaging",
  "competent_authority	",
  "irb_iec",
  "other_authority",
  "monitoring_documentation",
  "study_supplies",
  "site_correspondence",
  "equipment",
];
export const categoryPharmacyBinder = [
  "study_staff",
  "protocol_amendment",
  "schedule_of_events",
  "investigator_brochure",
  "pharmacy_manual",
  "msds_certificates",
  "investigational_receipt",
  "investigational_dispensing",
  "investigational_disposition",
  "investigational_storage",
  "training_material",
  "correspondence",
];

export const categoryPatientDocument = ["general_patient_document"];

class DocumentForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      sites: [],
      uploadHasChanged: false,
    };
  }

  async componentDidMount() {
    try {
      const { data } = await getSitesRequest();
      this.setState({ sites: data });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const document = { ...values };
          document.name = get(document, "document_file.fileList", []).slice(
            -1
          ).name;
          document.visibility = "per_site";
          document.document_file = values.document_file.file;

          const formData = new FormData();

          if (values.document_file && values.document_file.file) {
            formData.append("document_file", values.document_file.file);
          }
          formData.append("name", values.name);
          formData.append("content_type_code", values.content_type_code);
          formData.append("start_year", values.start_year.format("YYYY-MM-DD"));
          formData.append(
            "expiry_year",
            values.expiry_year ? values.expiry_year.format("YYYY-MM-DD") : null
          );

          if (values.type) {
            formData.append("type", values.type);
          }

          if (values.description) {
            formData.append("description", values.description);
          }

          if (values.uri) {
            formData.append("uri", values.uri);
          }

          formData.append("visibility", values.visibility);

          if (values.comments) {
            formData.append("comments", values.comments);
          }

          if (values.external_version) {
            formData.append("external_version", values.external_version);
          }
          formData.append("order_index", values.order_index);
          if (values.visibility === "per_site" || values.visibility === "per_site_private") {
            formData.append("site_id", values.site_id);
          }

          if (this.props.patient) {
            formData.append(
              "subject_profile_id",
              this.props.patient.profile.id
            );

            formData.append("site_id", this.props.patient.site.id);
          }

          if (this.props.id) {
            if (this.props.patient) {
              await updatePatientProfileDocumentRequest(
                this.props.id,
                formData
              );
            } else {
              await updateDocumentRequest(this.props.id, formData);
            }
          } else {
            if (this.props.patient) {
              await createPatientProfileDocumentRequest(formData);
            } else {
              await createDocumentRequest(formData);
            }
          }

          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: getFormErrorMessage(e, true),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};

            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: [
                    new Error(
                      JSON.stringify(
                        get(e, `response.data.errors.${errorFieldKey}`)
                      )
                    ),
                  ],
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  onCategoryChange = () => {
    this.props.form.setFieldsValue({ type: null });
  };

  render() {
    const { isLoading, requestResult, sites } = this.state;
    const {
      getFieldDecorator,
      getFieldValue,
      setFieldsValue,
    } = this.props.form;
    const {
      patientDocumentCreatePermission,
      documentUpdatePermission,
      patientDocumentUpdatePermission,
      documentCreatePermission,
      id,
      isNew,
      withPatient,
      etmfSchema,
    } = this.props;

    const categoryVal = getFieldValue("visibility");

    const createPermissions = withPatient
      ? patientDocumentCreatePermission
      : documentCreatePermission;
    const updatePermissions = withPatient
      ? patientDocumentUpdatePermission
      : documentUpdatePermission;

    const isEditable = id ? updatePermissions : createPermissions;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.id ? (
              <span>
                {this.props.name}{" "}
                <Badge
                  count={this.props.i18n.t("Edit")}
                  style={{ backgroundColor: "#2968AE" }}
                />
              </span>
            ) : isNew ? (
              this.props.i18n.t("NamespaceDocumentForm:Add New Document")
            ) : (
              ""
            )}
          </h4>

          {this.props.version && <div style={{ margin: '0 0 15px' }}>Version: {this.props.version}</div>}

          {!get(this.props, "patient.profile.id") && withPatient && (
            <Row>
              <Col>
                <Alert
                  type="error"
                  message={
                    this.props.i18n.t("Note") +
                    ": " +
                    this.props.i18n.t(
                      "NamespaceDocumentForm:You must create the profile for this subject in order to upload the documents!"
                    )
                  }
                />
                <br />
              </Col>
            </Row>
          )}

          <Row gutter={12}>
            <Col>
              <Form.Item>
                {getFieldDecorator("document_file", {
                  initialValue: get(this.props, "document_file", ""),
                  rules: [{ required: (this.state.uploadHasChanged || !this.props.url), message: this.props.i18n.t("Required" )}],
                })(
                  <Upload.Dragger
                    disabled={!isEditable}
                    accept=".doc,.docx,.odt,.txt,.xls,.xlsx,.ppt,.pptx,.pdf,.png,.jpg,.jpeg,.gif,.mp4,.eml,.msg,.zip,.csv,.vsdx,.xlsm,.xlsx,.accdb"
                    action=""
                    beforeUpload={() => false}
                    multiple={false}
                    fileList={get(
                      this.props.form.getFieldValue("document_file"),
                      "fileList",
                      []
                    ).slice(-1)}
                    onChange={(file) => {
                      this.setState({ uploadHasChanged: true });
                      if (!this.props.form.getFieldValue("name")) {
                        this.props.form.setFieldsValue({'name': get(file, 'file.name', '').replace(/\.[^/.]+$/, "")});
                      }
                    }}
                  >
                    <p className="ant-upload-drag-icon">
                      <Icon type="inbox" />
                    </p>
                    <p className="ant-upload-text">{this.props.i18n.t("Click or drag file to this area to upload")}</p>
                    <p className="ant-upload-hint">
                      {this.props.i18n.t("Support for a single file upload.")}
                    </p>
                    {/*<Button>
                      <Icon type="upload" />
                      {!this.props.form.getFieldValue("document_file") &&
                      this.props.url ? (
                        this.props.i18n.t("Change file")
                      ) : (
                        <span>
                          {this.props.i18n.t(
                            "NamespaceDocumentForm:Add New Document"
                          )}{" "}
                          <span style={{ color: "#f00" }}>*</span>
                        </span>
                      )}
                    </Button>*/}
                  </Upload.Dragger>
                )}
              </Form.Item>

              {!this.props.form.getFieldValue("document_file") &&
                this.props.url && (
                  <div>
                    <FileLink url={this.props.url} text="File preview" />
                    <br />
                    <br />
                  </div>
                )}
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("Index")}</b>
                <Form.Item style={{ marginBottom: "12px" }}>
                  {getFieldDecorator(`order_index`, {
                    initialValue: get(this.props, "order_index", ""),
                  })(<InputNumber disabled={!isEditable} placeholder="999" />)}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col>
              <label>
                <b>
                  {this.props.i18n.t("Category")}{" "}
                  <span style={{ color: "#f00" }}>*</span>
                </b>
                <Form.Item>
                  {getFieldDecorator("category", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "content_type_code")
                      ? findIndex(
                          get(etmfSchema, "schema", []),
                          ({ code }) =>
                            code ===
                            get(this.props, "content_type_code")
                              .split(".")[0]
                              .replace("T", "")
                        )
                      : undefined,
                  })(
                    <Select
                      disabled={!isEditable || this.props.blockCategories}
                      placeholder={this.props.i18n.t("Select category")}
                      style={{ width: "100%" }}
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      filterOption
                      onChange={() => {
                        setFieldsValue({
                          sub_category: undefined,
                          content_type_code: undefined,
                        });
                      }}
                    >
                      {get(etmfSchema, "schema", []).map(({ name }, index) => (
                        <Option key={index} value={index}>
                          {name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col>
              <label>
                <b>
                  {this.props.i18n.t("Sub Category")}{" "}
                  <span style={{ color: "#f00" }}>*</span>
                </b>
                <Form.Item>
                  {getFieldDecorator("sub_category", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "sub_category_code")
                      ? findIndex(
                          get(
                            etmfSchema,
                            `schema[${findIndex(
                              get(etmfSchema, "schema", []),
                              ({ code }) =>
                                code === this.props.primary_category_code
                            )}].sub_categories`,
                            []
                          ),
                          ({ code }) =>
                            code === this.props.sub_category_code
                        )
                      : undefined,
                  })(
                    <Select
                      disabled={!isEditable || this.props.blockCategories}
                      placeholder={this.props.i18n.t("Select sub category")}
                      style={{ width: "100%" }}
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      filterOption
                      onChange={() => {
                        setFieldsValue({
                          content_type_code: undefined,
                        });
                      }}
                    >
                      {get(
                        etmfSchema,
                        `schema[${getFieldValue("category")}].sub_categories`,
                        []
                      ).map(({ name }, index) => (
                        <Option key={index} value={index}>
                          {name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col>
              <label>
                <b>
                  {this.props.i18n.t("Content type")}{" "}
                  <span style={{ color: "#f00" }}>*</span>
                </b>
                <Form.Item>
                  {getFieldDecorator("content_type_code", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "content_type_code"),
                  })(
                    <Select
                      disabled={!isEditable || this.props.blockCategories}
                      placeholder={this.props.i18n.t("Select content type")}
                      style={{ width: "100%" }}
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      filterOption
                      onChange={() => {
                        setFieldsValue({
                          visibility: undefined,
                        });
                      }}
                    >
                      {get(
                        etmfSchema,
                        `schema[${getFieldValue(
                          "category"
                        )}].sub_categories[${getFieldValue(
                          "sub_category"
                        )}].content_types`,
                        []
                      ).map(({ name, code }) => (
                        <Option key={code} value={code}>
                          {name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>
                  {this.props.i18n.t("Visibility")}{" "}
                  <span style={{ color: "#f00" }}>*</span>
                </b>
                <Form.Item>
                  {getFieldDecorator("visibility", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "visibility"),
                  })(
                    this.props.patient ? (
                      <Select
                        disabled={!isEditable}
                        onChange={this.onCategoryChange}
                      >
                        <Option value="patient_documents">
                          {this.props.i18n.t(
                            "NamespaceDocumentForm:Patient documents"
                          )}
                        </Option>
                      </Select>
                    ) : get(
                        this.props.etmfSchemaLimits,
                        getFieldValue("content_type_code"),
                        []
                      ).length > 0 ? (
                      <Select
                        disabled={
                          !isEditable || !getFieldValue("content_type_code") || this.props.blockCategories
                        }
                        onChange={this.onCategoryChange}
                      >
                        {map(
                          get(
                            this.props.etmfSchemaLimits,
                            getFieldValue("content_type_code"),
                            []
                          ),
                          (item) => (
                            <Option key={item} value={item}>
                              {item.replace(/_/g, " ")}
                            </Option>
                          )
                        )}
                      </Select>
                    ) : (
                      <Select
                        disabled={
                          !isEditable || !getFieldValue("content_type_code") || this.props.blockCategories
                        }
                        onChange={this.onCategoryChange}
                      >
                        <Option
                          value="public"
                          disabled={!this.props.documentPublicReadPermission}
                        >
                          {this.props.i18n.t("Public")}
                        </Option>
                        <Option
                          value="general"
                          disabled={!this.props.documentGeneralReadPermission}
                        >
                          {this.props.i18n.t(
                            "NamespaceDocumentForm:Central Shared"
                          )}
                        </Option>
                        <Option
                          value="general_private"
                          disabled={
                            !this.props.documentGeneralPrivateReadPermission
                          }
                        >
                          {this.props.i18n.t(
                            "NamespaceDocumentForm:Central Private"
                          )}
                        </Option>
                        <Option
                          value="per_site"
                          disabled={!this.props.documentPerSiteReadPermission}
                        >
                          {this.props.i18n.t(
                            "NamespaceDocumentForm:Site Specific"
                          )}
                        </Option>
                        <Option
                          value="per_site_private"
                          disabled={!this.props.documentPerSitePrivateReadPermission}
                        >
                          {this.props.i18n.t(
                            "NamespaceDocumentForm:Site Specific Private"
                          )}
                        </Option>
                        <Option
                          value="training"
                          disabled={!this.props.documentTrainingReadPermission}
                        >
                          {this.props.i18n.t("Training")}
                        </Option>
                        <Option
                          value="validation"
                          disabled={
                            !this.props.documentValidationReadPermission
                          }
                        >
                          {this.props.i18n.t("Validation")}
                        </Option>
                        <Option
                          value="study_regulatory_binder"
                          disabled={
                            !this.props.documentStudyRegulatoryBinderPermission
                          }
                        >
                          {this.props.i18n.t("Study Regulatory Binder")}
                        </Option>
                        <Option
                          value="pharmacy_binder"
                          disabled={
                            !this.props.documentPharmacyBinderPermission
                          }
                        >
                          {this.props.i18n.t("Pharmacy Binder")}
                        </Option>
                      </Select>
                    )
                  )}
                </Form.Item>
              </label>
            </Col>

            {(categoryVal === "per_site" || categoryVal === "per_site_private") && (
              <Col lg={12}>
                <label>
                  <b>
                    {this.props.i18n.t("Site ID")}{" "}
                    <span style={{ color: "#f00" }}>*</span>
                  </b>
                  <Form.Item>
                    {getFieldDecorator("site_id", {
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      initialValue: get(this.props, "site_id"),
                    })(
                      <Select
                        disabled={!isEditable || this.props.blockCategories}
                        placeholder={this.props.i18n.t("Select Site ID")}
                        style={{ width: "100%" }}
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption
                      >
                        {sites.sort(
                          (a, b) =>
                            +`${a.code}`.split("-")[0] - +`${b.code}`.split("-")[0]
                        ).filter(({ state }) => state === 'active').map((site) => (
                          <Option key={site.id} value={site.id}>
                            {site.code} - {site.name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>
            )}
          </Row>

          <Row gutter={12}>

            <Col span={12}>
              <label>
                <b>
                  {this.props.i18n.t("Title")}{" "}
                  <span style={{ color: "#f00" }}>*</span>
                </b>
                <Form.Item>
                  {getFieldDecorator("name", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "name"),
                  })(<Input disabled={!isEditable} type="text" />)}
                </Form.Item>
              </label>
            </Col>

            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("URL")}</b>
                <Form.Item>
                  {getFieldDecorator("uri", {
                    initialValue: get(this.props, "uri"),
                  })(<Input disabled={!isEditable} type="text" />)}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>
                  {this.props.i18n.t("NamespaceDocumentForm:Year")}
                  <span style={{ color: "#f00" }}>*</span>
                </b>
                <Form.Item>
                  {getFieldDecorator("start_year", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "start_year")
                      ? moment(get(this.props, "start_year"))
                      : null,
                  })(
                    <DatePicker
                      disabled={!isEditable}
                      placeholder="yyyy-mm-dd"
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>
                  {this.props.i18n.t(
                    "NamespaceDocumentForm:Renewal/expiry year"
                  )}
                </b>
                <Form.Item>
                  {getFieldDecorator("expiry_year", {
                    initialValue: get(this.props, "expiry_year")
                      ? moment(get(this.props, "expiry_year"))
                      : null,
                  })(
                    <DatePicker
                      disabled={!isEditable}
                      placeholder="yyyy-mm-dd"
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>
          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>
                  {this.props.i18n.t("External version")}{" "}
                </b>
                <Form.Item>
                  {getFieldDecorator("external_version", {
                    initialValue: get(this.props, "external_version"),
                  })(<Input disabled={!isEditable} type="text" />)}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col>
              <label>
                <b>{this.props.i18n.t("Description")}</b>
                <Form.Item>
                  {getFieldDecorator("description", {
                    initialValue: get(this.props, "description"),
                  })(<Input.TextArea disabled={!isEditable} />)}
                </Form.Item>
              </label>
            </Col>
          </Row>
          <Row gutter={12}>
            <Col>
              <label>
                <b>{this.props.i18n.t("Comments")}</b>
                <Form.Item>
                  {getFieldDecorator("comments", {
                    initialValue: get(this.props, "comments"),
                  })(<Input.TextArea disabled={!isEditable} />)}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            {isEditable && (
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className={classes.submitButton}
                  disabled={
                    !get(this.props, "patient.profile.id") && withPatient
                  }
                >
                  {this.props.i18n.t("Save")}
                  {isLoading && <Icon type="loading" />}
                </Button>
                &nbsp; &nbsp;
              </Form.Item>
            )}

            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              {this.props.i18n.t("Cancel")}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  patientDocumentCreatePermission: getPatientDocumentCreatePermission(state),
  patientDocumentUpdatePermission: getPatientDocumentUpdatePermission(state),
  documentCreatePermission: getDocumentCreatePermission(state),
  documentUpdatePermission: getDocumentUpdatePermission(state),
  documentTrainingReadPermission: getDocumentTrainingReadPermission(state),
  documentValidationReadPermission: getDocumentValidationReadPermission(state),
  documentPublicReadPermission: getDocumentPublicReadPermission(state),
  documentGeneralReadPermission: getDocumentGeneralReadPermission(state),
  documentGeneralPrivateReadPermission: getDocumentGeneralPrivateReadPermission(
    state
  ),
  documentPerSiteReadPermission: getDocumentPerSiteReadPermission(state),
  documentPerSitePrivateReadPermission: getDocumentPerSitePrivateReadPermission(state),
  documentPharmacyBinderPermission: getDocumentPharmacyBinderPermission(state),
  documentStudyRegulatoryBinderPermission: getDocumentStudyRegulatoryBinderPermission(
    state
  ),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "user" })(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(DocumentForm))
);



// WEBPACK FOOTER //
// ./src/components/DocumentForm/DocumentForm.js